<script lang="ts">
  import { formatDateUS } from "@utils/dateTime";
  export let dateTime: Date | string | number;
</script>

<span>{formatDateUS(dateTime)}</span>
